const withrawEnabledDomain = [
  { subdomain: "fr", product: "mobiotv" },
  { subdomain: "uk", product: "mobiotv" },
  { subdomain: "lt", product: "mobiotv" },
  { subdomain: "pt", product: "videoflux" },
  { subdomain: "rs", product: "mobiotube" },
];

export const isWithdrawEnabled = (subdomain, product) => {
  return withrawEnabledDomain.some(
    (item) => item.subdomain === subdomain && item.product === product,
  );
};


// WEBPACK FOOTER //
// ./src/utils/withdraw-contract.js